var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-box",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"gallery-cover",attrs:{"src":_vm.info.pic,"alt":"活动封面"}}),(_vm.info.pic_title)?_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.pic_title))]):_vm._e(),(_vm.info.pic_desc)?_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.info.pic_desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }